import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import '../map.css';
import axios from 'axios';
import Sheet from 'react-modal-sheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../color';
import { v4 as uuidv4 } from 'uuid';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { LikeOutlined } from '@ant-design/icons';
import { EnvironmentOutlined, EnvironmentFilled, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';


const ShippingDriverMap = ({ }) => {



  const mapContainer = useRef(null);
  const map = useRef(null);
  const center = { lng: 50.5565184, lat: -72.3156992 };
  const [location, setLocation] = useState([]);


  const [zoom] = useState(12);

  const watchId = useRef(null);
  const userMarker = useRef(null);
  const routingControl = useRef(null);


  // class OpenRouteService {
  //     constructor(apiKey) {
  //       this.apiKey = apiKey;
  //     }

  //     route(waypoints, callback, options, callback2) {
  //       const waypointsStr = waypoints.map(wp => `${wp.latLng.lat},${wp.latLng.lng}`).join('|');
  //       const url = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${this.apiKey}&start=${waypoints[0].latLng.lat},${waypoints[0].latLng.lng}&end=${waypoints[1].latLng.lat},${waypoints[1].latLng.lng}`;

  //       fetch(url)
  //         .then(response => response.json())
  //         .then(data => {
  //         console.log(data)
  //           const route = data.features[0];
  //           const { geometry: { coordinates }, properties: { summary } } = route;
  //           const latLngs = coordinates.map(([lng, lat]) => L.latLng(lat, lng));
  //           const { duration, distance } = summary;
  //           callback(null, [{
  //             name: '',
  //             coordinates: latLngs,
  //             instructions: [],
  //             summary: { totalDistance: distance, totalTime: duration }
  //           }]);
  //         })
  //         .catch(callback);
  //     }
  //   }

  //   const openRouteService = new OpenRouteService('5b3ce3597851110001cf62485502b2c55edf439f8ecf0faa0eab4a75');

  useEffect(() => {
    if (location.length !== 0 && map.current) {
      if (routingControl.current) {
        map.current.removeControl(routingControl.current);
      }
      routingControl.current = L.Routing.control({
        // router: openRouteService,
        waypoints: [
          L.latLng(location[0], location[1]),
          L.latLng(18.4631, -72.2733),
        ],
      }).addTo(map.current);
    }
  }, [location]);

  useEffect(() => {
    if (map.current) return;

    map.current = new L.Map(mapContainer.current, {
      center: L.latLng(center.lat, center.lng),
      zoom: zoom
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map.current);

    watchId.current = navigator.geolocation.watchPosition(function (position) {
      setLocation([position.coords.latitude, position.coords.longitude]);

      if (userMarker.current) {
        map.current.removeLayer(userMarker.current);
      }

      const userIcon = L.icon({ iconUrl: require('../data/IconImageMap/currentLocation.png'), iconSize: [25, 41], iconAnchor: [12, 41] });
      userMarker.current = L.marker([position.coords.latitude, position.coords.longitude], { icon: userIcon }).addTo(map.current);

      map.current.flyTo([position.coords.latitude, position.coords.longitude], map.current.getZoom() + 5);
    });

    return () => {
      if (watchId.current) {
        navigator.geolocation.clearWatch(watchId.current);
      }
    };


  }, [center.lng, center.lat, zoom]);


  console.log("location", location)

  return (
    <div className="map-wrap">
      <div ref={mapContainer} className="map" style={{ zIndex: 0 }} />
    </div>
  )
}

export default ShippingDriverMap;